module.exports = require('./getCurrentDecoratedLocation')
